<div class="app-submit-form-container">


  <h1>Owner-Operator Program Application</h1>
  <p class="text-center">Fill out the required fields and take the next step in becoming an owner-operator!</p>

  <div class="hidden-scrolling-element" #myElement></div>

  <p class="submit-error-text"
     [style]="isDisplayInvalidMsg ? {'visibility': 'visible', 'margin-top': '0px'} : {'visibility': 'hidden', 'margin-top': '-37px'}">There was a problem with your submission. Please review the fields below.</p>

  <p class="submit-review-text"
     [style]="isReviewMsg ? {'visibility': 'visible', 'margin-top': '0px'} : {'visibility': 'hidden', 'margin-top': '-37px'}">Please review your information below before you hit submit. If any changes are needed, please click 'edit'.</p>


  <div class="row justify-content-md-center mt-4">
    <div class="col col-lg-12 col-md-12 col-sm-12">
      <form class="example-form" [formGroup]="data" (ngSubmit)="onSubmit()">

        <div class="row mb-4">
          <div class="col-lg-6 col-md-6 col-sm-6">
            <mat-label>Do you have a CDL? <span class="required-lable-txt">(Required)</span></mat-label>
            <mat-radio-group aria-label="Select an option" formControlName="cdlOwnerShip"
                             (change)="checkCdlChange($event)">
              <mat-radio-button [value]="true">Yes</mat-radio-button>
              <mat-radio-button [value]="false">No</mat-radio-button>
            </mat-radio-group>
            <mat-error style="padding: 0px 30px; margin-top: -25px;">
              <div *ngIf="data.get('cdlOwnerShip')?.hasError('required') && data.get('cdlOwnerShip')?.touched">
                You must select a value.
              </div>
            </mat-error>
          </div>

          <div *ngIf="data.get('cdlOwnerShip')?.value === true" class="col-lg-6 col-md-6 col-sm-6">
            <mat-label>How Long Have You Had It? <span class="required-lable-txt">(Required)</span></mat-label>
            <mat-form-field class="example-full-width">
              <mat-select formControlName="cdlLength" (selectionChange)="onCdlLengthChangeType($event)">
                <mat-option *ngFor="let option of HowLongHaveYouHadItList" [value]="option.key === 'true'">{{ option.value }}</mat-option>
              </mat-select>
              <mat-error>{{ getErrorMessage("cdlLength") }}</mat-error>
            </mat-form-field>

          </div>
        </div>

        <div class="row mb-3">
          <div class="col-lg-6 col-md-6 col-sm-6 mb-4">
            <mat-label>Do you have your own LLC? <span class="required-lable-txt">(Required)</span></mat-label>
            <mat-radio-group aria-label="Select an option" formControlName="llcOwnerShip"
                             (change)="checkLlcChange($event)">
              <mat-radio-button [value]="true">Yes</mat-radio-button>
              <mat-radio-button [value]="false">No</mat-radio-button>
            </mat-radio-group>
            <mat-error style="padding: 0px 30px; margin-top: -25px;">
              <div *ngIf="data.get('llcOwnerShip')?.hasError('required') && data.get('llcOwnerShip')?.touched">
                You must select a value.
              </div>
            </mat-error>
          </div>
          <div *ngIf="data.get('llcOwnerShip')?.value === true" class="col-lg-6 col-md-6 col-sm-6" style="position: relative">
            <mat-label>How Many Months? <span class="required-lable-txt">(Required)</span></mat-label>
            <mat-form-field class="example-full-width">
              <input matInput placeholder="" formControlName="llcLength"
                     type="number" min="0"
                     oninput="this.value=!!this.value && Math.abs(this.value)>=0?Math.abs(this.value):null">
            </mat-form-field>
            <span *ngIf="data.get('llcLength')?.invalid && data.get('llcLength')?.touched" class="month-custom-error">
              <mat-error *ngIf="data.get('llcLength')?.errors?.['required']">Months is required.</mat-error>
              <mat-error *ngIf="data.get('llcLength')?.errors?.['pattern']">Months must be a valid number.</mat-error>
              <mat-error *ngIf="data.get('llcLength')?.errors?.['max']">Months must be 100 or less.</mat-error>
            </span>

          </div>         
          <div *ngIf="data.get('llcOwnerShip')?.value === true" class="col-lg-6 col-md-6 col-sm-6">
            <mat-label>How Many Trucks Do You Operate? <span class="required-lable-txt">(Required)</span></mat-label>
            <mat-form-field class="example-full-width">
              <mat-select formControlName="fleetSize">
                <mat-option *ngFor="let option of HowManyTrucksDoYouOperateList" [value]="option.key">{{ option.value }}</mat-option>
              </mat-select>
              <mat-error>{{getErrorMessage("fleetSize")}}</mat-error>
            </mat-form-field>
          </div>
        </div>

        <div class="row">

          <div class="col col-lg-6 col-md-6 col-sm-6">
            <mat-label>First Name <span class="required-lable-txt">(Required)</span></mat-label>
            <mat-form-field class="example-full-width">
              <input matInput placeholder="" formControlName="firstName" required [readonly]="isReadOnly">
              <mat-error>{{getErrorMessage("firstName")}}</mat-error>
            </mat-form-field>
          </div>
          <div class="col col-lg-6 col-md-6 col-sm-6">
            <mat-label>Last Name <span class="required-lable-txt">(Required)</span></mat-label>
            <mat-form-field class="example-full-width">
              <input matInput placeholder="" formControlName="lastName" required [readonly]="isReadOnly">
              <mat-error>{{getErrorMessage("lastName")}}</mat-error>
            </mat-form-field>
          </div>

          <div class="col col-lg-12 col-md-12 col-sm-12">
            <mat-label>Address <span class="required-lable-txt">(Required)</span></mat-label>
            <mat-form-field class="example-full-width">
              <!--<input matInput placeholder="" formControlName="address" required>-->
              <input matInput formControlName="address1"
                     #placesRef="ngx-places"
                     ngx-gp-autocomplete
                     [options]='options'
                     (onAddressChange)="handleAddressChange($event)" />
              <mat-error>{{getErrorMessage("address1")}}</mat-error>
            </mat-form-field>

            <!--<input
            #placesRef="ngx-places"
            ngx-gp-autocomplete
            [options]='options'
            (onAddressChange)="handleAddressChange($event)" style="width: 100%" />-->

          </div>
          <!--<div class="col col-lg-12 col-md-12 col-sm-12">
            <mat-label>Street Address <span class="required-lable-txt">(Required)</span></mat-label>
            <mat-form-field class="example-full-width">
              <input matInput placeholder="" formControlName="streetAddress" required>
              <mat-error>{{getErrorMessage("streetAddress")}}</mat-error>
            </mat-form-field>
          </div>-->

          <div class="col col-lg-6 col-md-6 col-sm-6">
            <mat-label>Address Line 2</mat-label>
            <mat-form-field class="example-full-width">

              <input matInput placeholder="" formControlName="address2" [readonly]="isReadOnly">
            </mat-form-field>
          </div>
          <div class="col col-lg-6 col-md-6 col-sm-6">
            <mat-label>State <span class="required-lable-txt">(Required)</span></mat-label>
            <mat-form-field class="example-full-width">
              <mat-select formControlName="state">
                <mat-option *ngFor="let option of statelist" [value]="option.key">{{ option.value }}</mat-option>
              </mat-select>
              <mat-error>{{getErrorMessage("state")}}</mat-error>
            </mat-form-field>
          </div>

          <div class="col col-lg-6 col-md-6 col-sm-6">
            <mat-label>City <span class="required-lable-txt">(Required)</span></mat-label>
            <mat-form-field class="example-full-width">
              <input matInput placeholder="" formControlName="city" required [readonly]="isReadOnly">
              <mat-error>{{getErrorMessage("city")}}</mat-error>
            </mat-form-field>
          </div>
          <div class="col col-lg-6 col-md-6 col-sm-6">
            <mat-label>ZIP Code <span class="required-lable-txt">(Required)</span></mat-label>
            <mat-form-field class="example-full-width">
              <input matInput placeholder="" formControlName="postalcode" required [readonly]="isReadOnly">
              <mat-error>{{getErrorMessage("postalcode")}}</mat-error>
            </mat-form-field>
          </div>

          <div class="col col-lg-6 col-md-6 col-sm-6">
            <mat-label>Phone <span class="required-lable-txt">(Required)</span></mat-label>
            <mat-form-field class="example-full-width">
              <input matInput placeholder="(___)___-____" formControlName="mobilePhone" [mask]="maskPhonePattern" required [readonly]="isReadOnly">
              <mat-error>{{getErrorMessage("mobilePhone")}}</mat-error>
            </mat-form-field>
          </div>
          <div class="col col-lg-6 col-md-6 col-sm-6">
            <mat-label>Email <span class="required-lable-txt">(Required)</span></mat-label>
            <mat-form-field class="example-full-width">
              <input matInput placeholder="pat@example.com" formControlName="email" required [readonly]="isReadOnly">
              <mat-error>{{getErrorMessage("email")}}</mat-error>
            </mat-form-field>
          </div>

          <div class="col col-lg-6 col-md-6 col-sm-6">
            <mat-label>Date of Birth <span class="required-lable-txt">(Required)</span></mat-label>
            <mat-form-field class="example-full-width">
              <!--<input matInput placeholder="MM/DD/YYYY" [matDatepicker]="picker" [max]="maxDate"
              [mask]="maskDatePattern" formControlName="dateOfBirth" required [readonly]="isReadOnly">-->
              <input matInput placeholder="MM/DD/YYYY" [matDatepicker]="picker" [max]="maxDate" (change)="onDateInputChange($event)"
                     appDateMask formControlName="dateOfBirth" [readonly]="isReadOnly">
              <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
              <mat-error>{{getErrorMessage("dateOfBirth")}}</mat-error>
            </mat-form-field>
          </div>
          <div class="col col-lg-6 col-md-6 col-sm-6">
            <mat-label>SSN <span class="required-lable-txt">(Required)</span></mat-label>
            <mat-form-field class="example-full-width">
              <input matInput placeholder="___-__-____" formControlName="ssn" [mask]="maskSsnPattern" [readonly]="isReadOnly">
              <mat-error>{{getErrorMessage("ssn")}}</mat-error>
            </mat-form-field>
          </div>

          <!--<div class="col col-lg-6 col-md-6 col-sm-6">
          <mat-label>Truck</mat-label>
          <mat-form-field class="m-input-group">
            <input matInput type="search" placeholder="" formControlName="truck" [readonly]="true">-->
          <!--<button type="button" mat-button matSuffix mat-flat-button color="primary" aria-label="search" class="m-input-group-btn" (click)="openDialog()">Choose</button>-->
          <!--</mat-form-field>
          </div>-->
          <div class="col col-lg-6 col-md-6 col-sm-6">
            <mat-label>What are you planning on hauling?</mat-label>
            <mat-form-field class="example-full-width">
              <mat-select formControlName="planningOnHauling">
                <mat-option *ngFor="let option of planingOnHoulingList" [value]="option.key">{{ option.value }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="col col-lg-6 col-md-6 col-sm-6">
            <mat-label>What carrier will you be running for?</mat-label>
            <mat-form-field class="example-full-width">
              <input matInput placeholder="" formControlName="carrierName" [readonly]="isReadOnly">
            </mat-form-field>
          </div>
          <div class="col col-lg-6 col-md-6 col-sm-6">
            <mat-label>Will you be team driving? <span class="required-lable-txt">(Required)</span></mat-label>
            <mat-form-field class="example-full-width">
              <mat-select formControlName="teamDrive">
                <mat-option *ngFor="let option of teamDriveList" [value]="option.key">{{ option.value }}</mat-option>
              </mat-select>
              <mat-error>{{getErrorMessage("teamDrive")}}</mat-error>
            </mat-form-field>
          </div>
          <div class="col col-lg-6 col-md-6 col-sm-6">
            <mat-label>What is your expected weekly gross earnings?</mat-label>
            <mat-form-field class="example-full-width">
              <input matInput placeholder="" formControlName="expectedRevene"
                     type="number" min="0"
                     oninput="this.value=!!this.value && Math.abs(this.value)>=0?Math.abs(this.value):null"
                     [readonly]="isReadOnly">
              <mat-error>{{getErrorMessage("expectedRevene")}}</mat-error>
            </mat-form-field>
          </div>

          <div class="col col-lg-6 col-md-6 col-sm-6">
            <mat-label>How many miles do you expect to haul per week?</mat-label>
            <mat-form-field class="example-full-width">
              <input matInput placeholder="" formControlName="expectedMileage"
                     type="number" min="0"
                     #inputReference
                     oninput="this.value = !!this.value && Math.abs(this.value) >= 0 ? Math.abs(this.value) : null"
                     [readonly]="isReadOnly">
              <mat-error>{{getErrorMessage("expectedMileage")}}</mat-error>
            </mat-form-field>
          </div>

          <div *ngIf="isTruckDetailEnable" class="col col-lg-6 col-md-6 col-sm-6">
            <mat-label>Selected Truck</mat-label>
            <mat-card class="static-control-card">
              <mat-card-header class="mb-2">
                <!--<mat-card-title class="text-center">2022 FREIGHTLINER CASCADIA</mat-card-title>-->
                <mat-card-title class="text-center">{{truckData.year}} {{truckData.make}}</mat-card-title>
              </mat-card-header>
              <mat-card-content>

                <mat-divider class="mb-3"></mat-divider>

                <div class="row">
                  <div class="col-lg-4 col-md-4 col-sm-4">
                    <div class="c-label">Model</div>
                  </div>
                  <div class="col-lg-8 col-md-8 col-sm-8">
                    <div class="c-detail">{{truckData.model}}</div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg-4 col-md-4 col-sm-4">
                    <div class="c-label">Odometer</div>
                  </div>
                  <div class="col-lg-8 col-md-8 col-sm-8">
                    <div class="c-detail">{{truckData.originalMileage}}</div>
                  </div>
                </div>
                <!--<div class="row">
                  <div class="col-lg-12 col-md-12 col-sm-12 text-center">
                    <p class="c-price">PRICE: $78,200</p>
                  </div>
                </div>-->
              </mat-card-content>

            </mat-card>
          </div>

          <div *ngIf="referral_code" class="col col-lg-6 col-md-6 col-sm-6">
            <mat-label>Referral Code</mat-label>
            <mat-form-field class="example-full-width">
              <input matInput placeholder=""
                     #inputReference
                     [value]="referral_code"
                     [readonly]="true">
            </mat-form-field>
          </div>

        </div>

        <div class="row mt-3">
          <div class="col col-lg-12 col-md-12 col-sm-12 mb-2">
            <p class="social-link-title">How Did You Hear About Us?</p>
          </div>
          <div class="col-lg-12 col-md-12 col-sm-12">

            <mat-radio-group aria-label="Select an option" formControlName="marketingSource"
                             (change)="radioButtonChanged($event)" [disabled]="isReadOnly">
              <mat-radio-button value="google">Google</mat-radio-button>
              <mat-radio-button value="facebook">Facebook</mat-radio-button>
              <mat-radio-button value="twitter">Twitter</mat-radio-button>
              <mat-radio-button value="instagram">Instagram</mat-radio-button>
              <mat-radio-button value="linkedin">Linkedin</mat-radio-button>
              <mat-radio-button value="carrier">Carrier</mat-radio-button>
              <mat-radio-button value="family/friend">Family / Friend</mat-radio-button>
              <mat-radio-button value="bing">Bing</mat-radio-button>
            </mat-radio-group>
            <!--<mat-error style="padding: 0px 30px; margin-top: -25px;">
              <div *ngIf="data.get('marketingSource')?.hasError('required') && data.get('marketingSource')?.touched">
                You must select a value.
              </div>
            </mat-error>-->
          </div>
          <div class="col-lg-12 col-md-12 col-sm-12">
            <div *ngIf="isCarrierName">
              <mat-label>Carrier Name <span class="required-lable-txt">(Required)</span></mat-label>
              <mat-form-field class="example-full-width">
                <input matInput placeholder="" formControlName="srcCarrierName" required [readonly]="isReadOnly">
                <mat-error>{{getErrorMessage("srcCarrierName")}}</mat-error>
              </mat-form-field>
            </div>
            <div *ngIf="isFamilyFriend">
              <mat-label>Family/Friend, First and Last Name <span class="required-lable-txt">(Required)</span></mat-label>
              <mat-form-field class="example-full-width">
                <input matInput placeholder="" formControlName="familyFriend" required [readonly]="isReadOnly">
                <mat-error>{{getErrorMessage("familyFriend")}}</mat-error>
              </mat-form-field>
            </div>
          </div>

          <div class="col col-lg-12 col-md-12 col-sm-12 mt-5">

            <p>By submitting this application you consent to receive periodic commercial text messages from OTR Leasing at the phone number provided above. Consent not a condition of purchase. Message and Data rates may apply. You will receive a confirmation message. Text STOP to opt out. By clicking submit, you agree to receive text messages from OTR Leasing. I further understand that my information will only be used as described here and <a href="https://otrleasing.com/privacy-policy/" target="_blank" class="">https://otrleasing.com/privacy-policy/</a></p>

            <p>The Applicant (which term includes the business entity named above as each of guarantor principal, partner, member, owner) authorizes OTR Leasing, LLC and its successors and/or assigns (“OTR”), its Service Providers, and any credit bureau or other investigative agency engaged by OTR to investigate, obtain and share information from time to time from any source (included, but not limited to references listed in the Lease Application ) about Applicant’s credit standing and responsibility, including, but not limited to, obtaining credit reports and other OTR information to evaluate this application and to review Applicant’s account. By signing this Commercial Lease Application, Applicant authorizes OTR, its affiliates, and assignees to share the Applicant’s credit and other information as permitted by law. The Applicant represents and warrants to OTR that: (a) all of the representations and information provided in this application, and all other representations, statements, reports or information made or delivered to OTR are true, complete and correct in every respect; and (b) Applicant is requesting that OTR extend credit or enter into transactions with Applicant for commercial and business purposes only, and such transactions are not for personal, family or household purposes. Applicant represents that it has reviewed this document and the information herein is true, correct and complete. OTR has or will obtain and keep on file information complying with 31 CFR Part 103.121 regarding each Applicant, including your name, address and copies of various identifying documents. ECOA NOTICE: The Federal Equal Credit Opportunity Act prohibits creditors from discriminating against credit applications on the basis of race, color, religion, national origin, sex, marital status, age (provided the applicant has the capacity to enter into a binding contract) because all or part of the applicant’s income derives from any public assistance program or because the applicant has in good faith exercised any right under the Consumer Credit Protection Act. The federal agency that administers compliance with this law concerning this creditor is the Federal Trade Commission, 10877 Wilshire Blvd., Suite 700, Los Angeles, California 90024 or also the Federal Trade Commission, Consumer Response Center, Washington, DC 20580 the FDIC, Consumer Response Center, 1100 Walnut Street, Box #11, Kansas City, MO 64106. If OTR takes adverse action against you, you have the right to a written statement of the specific reasons for the denial. Adverse action may include refusal to grant credit in substantially the amount or terms requested, termination or an unfavorable change in the terms of an account and refusal to increase the amount of credit available. To obtain the statement, please contact in writing, within 60 days from the date you are notified of our decision. We will send you a written statement within 30 days of receiving your request.</p>

            <p>By pressing submit application, I certify my intent to electronically sign this Application. This electronic signature ensures that I am the Applicant as provided and identified in the Application, indicates my approval of the information, terms and conditions contained in the Application, affirms the accuracy of the information provided in the Application and serves as my intent to sign. I acknowledge, accept and understand that my electronic signature is admissible in court and constitutes a written and electronic signature in accordance with The Federal Global and National Commerce Act and The Uniform Electronic Transactions Act as in effect in any relevant jurisdiction, including, without limitation, the state of Kansas. Further, by checking this box and pressing submit, I acknowledge that I have read and understand the terms and conditions of this Application in their entirety.</p>

          </div>
        </div>

        <div class="row mt-3">
          <div class="col col-lg-12 col-md-12 col-sm-12">
            <!--<p>Local Host</p>-->
            <!--[siteKey]="'6LciK5EpAAAAADHwxyKDpq9YpkT08SmwfZy0WZtS'"-->
            <!--<p>awesometechinc.com</p>-->
            <!--[siteKey]="'6LdbS5UpAAAAALQBRVL2L0LJpM9pXcTbXfIB3com'"-->
            <!--<p>azurewebsites.net</p>-->
            <!--[siteKey]="'6LcHY6QpAAAAALIblEggIVUo9nPKGYdk766OCc4O'"-->
            <!--<p>otrleasing.com</p>-->
            <!--[siteKey]="'6Le8BLgpAAAAAJY1_p1lp-RTfUgcbvOBKHMUiZEO'"-->
            <!--<p>otrleasingDevReCaptchaKey</p>-->
            <!--[siteKey]="'6LfiR80pAAAAAN7N7n9rxMTfFKjmcciVa0ycpSUP'"-->
            <ngx-recaptcha2 #captchaElem
                            [siteKey]="'6Le8BLgpAAAAAJY1_p1lp-RTfUgcbvOBKHMUiZEO'"
                            [useGlobalDomain]="false"
                            formControlName="recaptcha">
            </ngx-recaptcha2>

          </div>
        </div>

        <div class="row justify-content-md-center mt-5">
          <div class="col col-lg-6">
            <button *ngIf="isReview" mat-stroked-button color="primary" type="button" (click)="onReviewBtnClick()" [disabled]="btnLoading">
              Submit <mat-icon *ngIf="btnLoading"><mat-spinner color="warn" diameter="30"></mat-spinner></mat-icon>
            </button>
          </div>
        </div>

        <div class="row justify-content-md-center mt-3">
          <div class="col col-lg-3 col-md-4 col-sm-12 col-xs-12">
            <button *ngIf="isEditOrSubmitEnable" mat-stroked-button color="primary" type="button" class="blue-btn" (click)="onEditBtnClick()">Edit</button>
          </div>
          <div class="col col-lg-5 col-md-7 col-sm-12 col-xs-12">
            <button *ngIf="isEditOrSubmitEnable" mat-stroked-button color="primary" type="submit">Submit</button>
          </div>
        </div>


      </form>
    </div>
  </div>

</div>
